import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import AppBar from '@material-ui/core/AppBar';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';

import { withStyles } from '@material-ui/core/styles';

import AddIcon from '@material-ui/icons/Add';
import amber from '@material-ui/core/colors/amber';

import { CardList } from '../../core';
import CrewCards from '../Crew/CrewCards';
import VendorCards from '../Vendors/VendorCards';
import WorkTypeCards from '../WorkTypes/WorkTypeCards';
import TaxCategoryCards from '../TaxCategories/TaxCategoryCards';

import {
  helpDispatch,
  OverlayElevator,
  Tooltip,
  TooltipTypes
} from 'components/admin/Help';

import {
  ClientCards,
} from '../Clients';

import {
  ClientDialog,
  VendorDialog,
  CrewDialog,
  WorkTypeDialog,
  TaxCategoryDialog,
} from '../Dialogs';

import {
  setClientForm,
  setVendorForm,
  setWorkTypeForm,
  setCrewForm,
  setTaxCategoryForm,
} from '../../../store/actions';

import {
  selectCrewList,
  selectVendorsList,
  selectWorkTypesList,
  selectTaxCategoriesList,
} from '../../../store/selectors';

const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  button: {
    backgroundColor: amber[500],
    color: "#fff",
    marginRight: theme.spacing.unit*6,
  },
  row: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingTop: theme.spacing.unit*2,
    paddingBottom: theme.spacing.unit*2,
  },
  margin: {
    marginLeft: theme.spacing.unit*2,
    marginRight: theme.spacing.unit*2,
  },
  elevate: {
    zIndex: theme.zIndex.tooltipAction,
  }
});

function TabContainer(props) {
  return (
    <Typography component="div" style={{ padding: 8 * 3 }}>
      {props.children}
    </Typography>
  );
}

TabContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

class SetupDetail extends Component {
  timer = null;

  constructor(props){
    super(props);
    this.state = {
      selectedTab: "clients",
      dialogType: undefined,
    }
  }

  handleChange = (event, selectedTab) => {
    this.setState({ selectedTab });
  };

  handleAdd = () => {
    this.setState({ dialogType: this.state.selectedTab })
  };

  handleClose = () => this.setState({dialogType: undefined});

  componentWillUnmount() {
    clearTimeout(this.timer);
  }

  render() {
    const {
      classes,
      setClientForm,
      setVendorForm,
      setWorkTypeForm,
      setCrewForm,
      setTaxCategoryForm,
      crew,
      taxCategories,
      vendors,
      workTypes,
      help,
    } = this.props;
    const {
      selectedTab,
      dialogType,
    } = this.state;

    return (
      <div className={classes.root}>
        {dialogType === "clients" &&
          <ClientDialog
            show={true}
            handleClose={this.handleClose}
          />
        }
        {dialogType === "crew" &&
          <CrewDialog
            show={true}
            handleClose={this.handleClose}
          />
        }
        {dialogType === "vendors" &&
          <VendorDialog
            show={true}
            handleClose={this.handleClose}
          />
        }
        {dialogType === "worktypes" &&
          <WorkTypeDialog
            show={true}
            handleClose={this.handleClose}
          />
        }
        {dialogType === "taxcategories" &&
          <TaxCategoryDialog
            show={true}
            handleClose={this.handleClose}
          />
        }
        <Card className={classes.card}>
          <div className={classes.row}>
            <div className={classes.header}>
              <Avatar className={classNames(classes.avatar, classes.margin)}>
                S
              </Avatar>
              <Typography variant="headline">
                Setup
              </Typography>
            </div>
            <Tooltip type={TooltipTypes.setup.ADD_CLIENT} placement="bottom">
              <Button
                className={classNames(classes.button, help.isCurrentStep(TooltipTypes.setup.ADD_CLIENT) && classes.elevate)}
                variant="fab"
                aria-label="add"
                onClick={() => {
                  helpDispatch(TooltipTypes.ADD_INVOICE);
                  this.handleAdd();
                }}
                >
                <AddIcon />
              </Button>
            </Tooltip>
          </div>
        </Card>
        <AppBar position="static" color="default">
          <Tabs
            value={selectedTab}
            onChange={this.handleChange}
            indicatorColor="primary"
            textColor="primary"
            scrollable
            scrollButtons="auto"
          >
            <Tab label="Clients" value="clients"/>
            <Tooltip type={TooltipTypes.setup.TABS} placement="bottom">
              <div />
            </Tooltip>
            <Tab label="Crew" value="crew"/>
            <Tab label="Vendors" value="vendors"/>
            <Tab label="Work Types" value="worktypes"/>
            <Tab label="Tax Categories" value="taxcategories"/>
          </Tabs>
        </AppBar>
        {selectedTab === "clients" &&
          <TabContainer>
            <ClientCards
              handleEdit={(item) => {
                const { setClientForm } = this.props;
                setClientForm(item);
                this.setState({ dialogType: this.state.selectedTab });
              }}
            />
          </TabContainer>
        }
        {selectedTab === "crew" &&
          <TabContainer>
            <CrewCards
              handleSelect={(item) => {
                const { setCrewForm } = this.props;
                setCrewForm(item);
                this.setState({ dialogType: this.state.selectedTab });
              }}
            />
          </TabContainer>
        }
        {selectedTab === "vendors" &&
          <TabContainer>
            <VendorCards
              handleSelect={(item) => {
                const { setVendorForm } = this.props;
                setVendorForm(item);
                this.setState({ dialogType: this.state.selectedTab });
              }}
            />
          </TabContainer>
        }
        {selectedTab === "worktypes" &&
          <TabContainer>
            <WorkTypeCards
              handleSelect={(item) => {
                const { setWorkTypeForm } = this.props;
                setWorkTypeForm(item);
                this.setState({ dialogType: this.state.selectedTab });
              }}
            />
          </TabContainer>
        }
        {selectedTab === "taxcategories" &&
          <TabContainer>
            <TaxCategoryCards
              handleSelect={(item) => {
                const { setTaxCategoryForm } = this.props;
                setTaxCategoryForm(item);
                this.setState({ dialogType: this.state.selectedTab });
              }}
            />
          </TabContainer>
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  crew: selectCrewList(state),
  vendors: selectVendorsList(state),
  workTypes: selectWorkTypesList(state),
  taxCategories: selectTaxCategoriesList(state),
  help: state.help,
});

const mapDispatchToProps = {
  setClientForm,
  setVendorForm,
  setWorkTypeForm,
  setCrewForm,
  setTaxCategoryForm,
};

export default compose(
  withStyles(styles),
  connect(mapStateToProps, mapDispatchToProps)
)(SetupDetail);



// WEBPACK FOOTER //
// ./src/components/admin/Setup/SetupDetail.jsx